import React from 'react';

import Icon, { GLYPHS } from '../../../common/icon';
import RoleAwareLink from '../../../common/RoleAwareLink';
import { staffMemberProp } from './shapes';
import UserType from '../../../admin/users/components/Shared/userType';

const StaffListItem = ({ staffMember }) => (
  <RoleAwareLink className="c-table-card__row" to={`/staff/${staffMember.id}`}>
    <div className="c-table-card__cell u-1/2">
      <div className="u-text-trim">
        <span className="c-avatar u-mr--">
          <Icon glyph={GLYPHS.customers} size="medium" />
        </span>
        <span className="u-mr--">{staffMember.username}</span>
      </div>
    </div>
    <div className="c-table-card__cell u-1/2">
      <div className="u-text-trim">
        <UserType user={staffMember} />
      </div>
    </div>
  </RoleAwareLink>
);

StaffListItem.propTypes = {
  staffMember: staffMemberProp.isRequired,
};

export default StaffListItem;
